import { render, staticRenderFns } from "./TranslationBaseView.vue?vue&type=template&id=79efb20a&"
import script from "./TranslationBaseView.vue?vue&type=script&lang=js&"
export * from "./TranslationBaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports